import {
  TextField,
  TextInput,
  WrapperField,
  EditButton,
  TopToolbar,
  CreateButton,
  FunctionField,
  ShowButton,
  SelectInput,
  NullableBooleanInput,
  SelectField,
} from 'react-admin';

import ClearFiltersButton from 'src/components/ClearFiltersButton';
import CraftList from 'src/components/CraftList';
import AuditBasedStatusFilterInput from 'src/inputs/AuditBasedStatusFilterInput';
import BulkSoftDeleteButton from 'src/components/BulkSoftDeleteButton';
import { usePermissions } from 'src/hooks';
import { DataPackageKind, DataPackageRecord } from 'src/types';
import { DATA_PACKAGE_KINDS } from 'src/utils/defaults/Constants';

const columnStyles = {
  actions: {
    width: '12rem',
    '& :nth-child(n + 2)': {
      ml: 0.5,
    },
  },
};

const filters = [
  <TextInput key="nameFilter" source="name" alwaysOn />,
  <AuditBasedStatusFilterInput key="statusFilter" source="deleted_at@_is_null" alwaysOn />,
  <SelectInput key="kindFilter" source="kind" choices={DATA_PACKAGE_KINDS} alwaysOn />,
  <NullableBooleanInput key="isDeprecatedFilter" source="is_deprecated" label="Deprecated" alwaysOn />,
];

const ListActions = ({ canCreate }: { canCreate: boolean }) => (
  <TopToolbar>
    <ClearFiltersButton />
    {canCreate && <CreateButton />}
  </TopToolbar>
);

export const DataPackagesList = () => {
  const { permissions } = usePermissions();

  const canEdit = permissions.has('dataPackage:edit');
  const canDelete = permissions.has('dataPackage:delete');

  const bulkActionButtons = canDelete && (
    <BulkSoftDeleteButton label="Delete Selected" data={{ deleted_at: new Date().toISOString() }} />
  );

  return (
    <CraftList
      title="Data Packages"
      filters={filters}
      filterDefaultValues={{
        'deleted_at@_is_null': true,
        kind: DataPackageKind.STANDARD,
        is_deprecated: false,
      }}
      actions={<ListActions canCreate={canEdit} />}
      showClearButton={false}
      deletePermission="dataPackage:delete"
      dataGridProps={{
        bulkActionButtons,
      }}
      columnStyles={columnStyles}
    >
      <TextField label="ID" source="id" />
      <TextField source="name" />
      <SelectField source="kind" choices={DATA_PACKAGE_KINDS} />
      <WrapperField label="Actions" headerClassName="column-actions" cellClassName="column-actions">
        <ShowButton />
        {canEdit && (
          <FunctionField
            render={(rec: DataPackageRecord) => (
              <EditButton disabled={rec.kind === DataPackageKind.INTERNAL || !!rec.deleted_at} />
            )}
          />
        )}
      </WrapperField>
    </CraftList>
  );
};

export default DataPackagesList;
